<template>
  <base-material-card
    color="primary"
    icon="mdi-barcode-scan"
    inline
    class="px-5 py-4 ml-0"
  >
    <template v-slot:after-heading>
      <div class="display-2 font-weight-light">
        {{ title }}
      </div>
    </template>
    <v-form class="mt-5">
      <v-row align="center" class="mx-auto">
        <v-col cols="12" class="pb-1">
          <validation-provider v-slot="{ errors }" rules="required|max:100" id="titulo-variacao-preco-unitario">
            <v-text-field
              label="Título"
              outlined
              :error-messages="errors"
              v-model="campos.titulo"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row align="center" class="mx-auto">
        <v-col cols="12" class="pt-0 pb-1">
          <validation-provider v-slot="{ errors }" rules="required" id="tucs-variacao-preco-unitario">
            <v-select
              :items="tucList"
              v-model="campos.tucs"
              outlined
              multiple
              small-chips
              clearable
              clear-icon="mdi-close-circle"
              label="TUCs"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row align="center" class="mx-auto">
        <v-col cols="12" class="pt-0 pb-1">
          <validation-provider v-slot="{ errors }" rules="required" id="variaveis-variacao-preco-unitario">
            <v-select
              :items="variaveisList"
              v-model="campos.variaveis"
              outlined
              multiple
              small-chips
              clearable
              clear-icon="mdi-close-circle"
              label="Variáveis"
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
  
</template>

<script>

export default {
  name: "ParametrosVariacaoPrecoUnitario",

  components: {},

  props: {
    variacao: {
      required: false,
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      campos: {
        titulo: "",
        tucs: [],
        variaveis: []
      },
      tucList: ["125", "135", "160", "190", "210", "255","295", "330", "340", "345", "395", "565", "570", "575", "580"],
      variaveisList: [
        { value: "ValorUnitario", text: "Valor Unitário" },
        { value: "AliquotaICMS", text: "Alíquota ICMS" }, 
        { value: "AliquotaIPI", text: "Alíquota IPI" }
      ],
    }
  },

  computed: {
    title() {
      return this.$route.params.id ? "Editando Variação de Preço Unitário" : "Adicionar Variação de Preço Unitário";
    },
    user() {
      return this.$store.getters.getUser;
    },
  },

  watch: {
    variacao() {
      this.fillFields();
    }
  },

  methods: {
    exportData() {
      return {
        nome: this.campos.titulo,
        parametros: {
          tucs: this.campos.tucs,
          vars: this.campos.variaveis,
        }
      }
    },
    fillFields() {
      const item = this.variacao;

      this.campos.titulo = item.nome;
      this.campos.tucs = item.parametros?.tucs;
      this.campos.variaveis = item.parametros?.vars;
    },
  },
}
</script>

<style>
</style>